import { ChainId, Currency, CurrencyAmount, ETHER, Token, TokenAmount, WETC } from '@etcswapv2/sdk-legacy'

export function wrappedCurrency(currency: Currency | undefined, chainId: ChainId | undefined): Token | undefined {
  // Use 'address' property check instead of reference equality to avoid module duplication issues
  // Native currency (ETC/ETHER) has no 'address' property
  if (!currency) return undefined
  if (!chainId) return undefined
  if (!('address' in currency)) return WETC[chainId]
  return currency as Token
}

export function wrappedCurrencyAmount(
  currencyAmount: CurrencyAmount | undefined,
  chainId: ChainId | undefined
): TokenAmount | undefined {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : undefined
  return token && currencyAmount ? new TokenAmount(token, currencyAmount.raw) : undefined
}

export function unwrappedToken(token: Token): Currency {
  if (token.equals(WETC[token.chainId])) return ETHER
  return token
}
